import type { Dispatch } from "@reduxjs/toolkit";
import { WorkOrdersSummaryTable } from "../../ticket/WorkOrdersSummaryTable";
import type { TurbineViewRenderProps } from "./TurbineViewRender";
import { Card } from "../../../common/components/Card";

type WorkOrdersInfoProps = TurbineViewRenderProps & { dispatch: Dispatch };

export const WorkOrdersInfo = ({ intl, turbineData, dispatch }: WorkOrdersInfoProps) => {
  const { turbine, tickets, ticketSideload, serviceObjects } = turbineData;

  // The ticket list is shared with other pages, so it may still hold their
  // tickets until this turbine's work orders have been fetched.
  const turbineTickets = Object.values(tickets.results.tickets).filter(
    (ticket) => ticket.turbine === turbine.id
  );

  return (
    <Card title={intl.formatMessage({ id: "work_orders" })}>
      <WorkOrdersSummaryTable
        intl={intl}
        dispatch={dispatch}
        tickets={turbineTickets}
        ticketSideload={ticketSideload}
        serviceObjects={serviceObjects}
        showTurbineColumn={false}
      />
    </Card>
  );
};
